var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-preview"},[_c('h2',{staticClass:"first"},[_c('i',{staticClass:"af-icons af-icons-preview"}),_vm._v(" "+_vm._s(_vm.heading)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }